import { AuthConfig } from '@auth0/auth0-angular';

export enum AppFeature {
  PRICE_REQUEST = 'priceRequest',
  CONSENT_DIALOG_NORMAL_CHANGE = 'consentDialogNormalChange',
  CARTRIDGE_VARIANT_OWNER_REPLACEMENT = 'cartridgeVariantOwnerReplacement',
  CAPTCHA = 'captcha',
  IAM_TOGGLE = 'iamToggle',
  GUIDED_TOUR = 'guidedTour',
  ROLE_LIMITS = 'roleLimits',
}

export type AppConfiguration = {
  apiUrl: {
    [key: string]: string;
  };
  auth: AuthConfig;
  basicAuthCredentials?: string;
  features?: Record<AppFeature, string | undefined>;
  guidedTour: {
    orgAdminIntroduction: {
      highlightedServiceId: string;
    };
  };
  hcaptchaSiteKey?: string;
  notificationCheckInterval: number;
  logoutPageUrl: string;
  platformVersion: string;
  publicEndpoints: { route: string; httpMethods: string[] }[];
  stage: Stage;
  supportPortalUrl: string;
  supportWidgetUrl: string;
  supportWidgetId: number;
};

export type EnvironmentConfiguration = {
  apiManagementBaseUrl?: string;
  auth?: {
    domain: string;
    clientId: string;
    apiAudience: string;
  };
  basicAuthCredentials?: string;
  features?: FeatureToggleConfiguration;
  guidedTour?: {
    orgAdminIntroduction: {
      highlightedServiceId: string;
    };
  };
  iamToggleAuth?: {
    domain: string;
    clientId: string;
    apiAudience: string;
  };
  hcaptchaSiteKey?: string;
  leistungPrototype?: {
    uri: string;
    apiAudience: string;
  };
  notificationCheckInterval: number;
  platformVersion: string;
  stage: Stage;
  supportPortalUrl: string;
  supportWidgetUrl: string;
  supportWidgetId: number;
};

export enum Stage {
  LOCAL = 'local',
  DEV = 'dev',
  TEST = 'test',
  ACCEPT = 'accept',
  PROD = 'prod',
}

type FeatureToggleConfiguration = {
  priceRequestEnabled?: string;
  consentDialogNormalChangeEnabled?: string;
  cartridgeVariantOwnerReplacementEnabled?: string;
  captchaEnabled?: string;
  guidedTourEnabled?: string;
  roleLimitsEnabled?: string;
};
